import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import "./App.css"

import Home from './Components/Home/Home';
import About from './Components/About/About';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import Service from './Components/Service/Service';
import DirectorsSection from './Components/Director/Director';
import Ourteam from './Components/OurTeam/Ourteam';
import Faq from './Components/Faq/Faq';
import Contact from './Components/Contact/Contact';
import Ourbranches from './Components/Ourbranches/Ourbranches';
import Architecture from './Components/Service/Pages/Architecture';
import Hospitalmanagementconsultancy from './Components/Service/Pages/Hospitalmanagementconsultancy';
import Operation from './Components/Service/Pages/Operation';
import Deligence from './Components/Service/Pages/Deligence';
import Financial from './Components/Service/Pages/Financial';
import Architechtualdesign from './Components/Service/Subpages/Architechtualdesign';
import Hospitalprojectmanagement from './Components/Service/Subpages/Hospitalprojectmanagement';
import Masterplaning from './Components/Service/Subpages/Masterplaning';
import Medicalplanning from './Components/Service/Subpages/Medicalplanning';
import Remodelling from './Components/Service/Subpages/Remodelling';
import Turnkey from './Components/Service/Subpages/Turnkey';
import MarketFeasibility from './Components/Service/Hospital Management Consultancy/MarketFeasibility';
import Accreditation from './Components/Service/Hospital Management Consultancy/Accreditation';
import BusinessModelling from './Components/Service/Hospital Management Consultancy/BusinessModelling';
import CommissioningAssistance from './Components/Service/Hospital Management Consultancy/CommissioningAssistance';
import HospitalInformationSystem from './Components/Service/Hospital Management Consultancy/HospitalInformationSystem';
import ProfitMaximization from './Components/Service/Hospital Management Consultancy/ProfitMaximization';
import InventoryManagement from './Components/Service/Hospital Management Consultancy/InventoryManagement';
import MedicalEquipmentPlanning from './Components/Service/Hospital Management Consultancy/MedicalEquipmentPlanning';
import BusinessDevelopment from './Components/Service/Hospital Operations & Management/BusinessDevelopment';
import HRTraining from './Components/Service/Hospital Operations & Management/HRTraining';
import Marketing from './Components/Service/Hospital Operations & Management/Marketing';
import OperationsManagement from './Components/Service/Hospital Operations & Management/OperationsManagement';
import TPAManagement from './Components/Service/Hospital Operations & Management/TPAManagement';
import AssignmentStudy from './Components/Service/Hospital Financial Management/AssignmentStudy';
import CostReduction from './Components/Service/Hospital Financial Management/CostReduction';
import DaytoDayAccounting from './Components/Service/Hospital Financial Management/DaytoDayAccounting';
import FinancialGrowthStrategy from './Components/Service/Hospital Financial Management/FinancialGrowthStrategy';
import InternalExternalAudit from './Components/Service/Hospital Financial Management/InternalExternalAudit';
import MergerAcquisition from './Components/Service/Hospital Financial Management/MergerAcquisition';



export default function App() {
  return (
    <>
       <Router>
     <Navbar/>
          <Routes>
            <Route path="/about" element={<About/>} />
            <Route path="/" element={<Home/>}/>
            <Route path="/service" element={<Service/>}/>
            <Route path="/director" element={<DirectorsSection/>}/>
              <Route path="/ourteam" element={<Ourteam/>}/>
              <Route path="/faq" element={<Faq/>}/>
              <Route path="/contact" element={<Contact/>}/>
              <Route path="/ourbranches" element={<Ourbranches/>}/>
              
              <Route path="/services/architecture-planning-designing" element={<Architecture/>}/>
              <Route path="/services/management-consultancy" element={<Hospitalmanagementconsultancy/>}/>
              <Route path="/services/operations-management" element={<Operation/>}/>
              <Route path="/services/due-diligence-overview" element={<Deligence/>}/>
              <Route path="/services/financial-management" element={<Financial/>}/>
              <Route path="/services/design-review" element={<Architechtualdesign/>}/>
              <Route path="/services/project-management" element={<Hospitalprojectmanagement/>}/>
              <Route path="/services/master-planning" element={<Masterplaning/>}/>
              <Route path="/services/medical-planning" element={<Medicalplanning/>}/>
              <Route path="/services/remodelling-expansion" element={<Remodelling/>}/>
              <Route path="/services/turnkey-architecture" element={<Turnkey/>}/>

              <Route path="/services/feasibility" element={<MarketFeasibility/>}/>
              <Route path="/services/accreditation" element={<Accreditation/>}/>
              <Route path="/services/business-modelling" element={<BusinessModelling/>}/>
              <Route path="/services/commissioning" element={<CommissioningAssistance/>}/>
              <Route path="/services/his" element={<HospitalInformationSystem/>}/>
              <Route path="/services/profit-maximization" element={<ProfitMaximization/>}/>
              <Route path="/services/inventory" element={<InventoryManagement/>}/>
              <Route path="/services/equipment-planning" element={<MedicalEquipmentPlanning/>}/>

              <Route path="/services/business-development" element={<BusinessDevelopment/>}/>
              <Route path="/services/hr-training" element={<HRTraining/>}/>
              <Route path="/services/marketing" element={<Marketing/>}/>
              <Route path="/services/operations" element={<OperationsManagement/>}/>
              <Route path="/services/tpa" element={<TPAManagement/>}/>

              <Route path="/services/assessment" element={<AssignmentStudy/>}/>
              <Route path="/services/cost-reduction" element={<CostReduction/>}/>
              <Route path="/services/accounting" element={<DaytoDayAccounting/>}/>
              <Route path="/services/financial-growth" element={<FinancialGrowthStrategy/>}/>
              <Route path="/services/audit" element={<InternalExternalAudit/>}/>
              <Route path="/services/MergerAcquisition" element={<MergerAcquisition/>}/>

          </Routes>  
        <Footer/>
        </Router>
    </>
  )
}
